export default __webpack_public_path__ + "static/media/meta-mask-logo.20194f52.svg";